import { Addition, Subtraction } from "../../../CommonFunction/CalculationsWithDecimalValues";
import { replaceUnderscore } from "../../../CommonFunction/common";
import { convertToISO } from "../../../CommonFunction/IsoDateTime";

let Accounts = {
  Input: {
    SGST: "67b5709fbd2735f680a2041d",
    CGST: "67b57088bd2735f680a2041c",
    IGST: "67b5705cbd2735f680a2041b",
  },
  Output: {
    SGST: "67b570eabd2735f680a20420",
    CGST: "67b570d0bd2735f680a2041f",
    IGST: "67b570b9bd2735f680a2041e",
  },
};
export const createTransaction = (data, Entry_For, FormDataFromRedux, formData = {}, formKey, Type) => {
  let { MasterData } = FormDataFromRedux;
  MasterData = MasterData[formKey];
  console.log(data, Entry_For, formKey, formKey == "Sales_Return");
  if (Entry_For === "Sales" && MasterData) {
    let TransactionMap = {};
    let TotalAmount = 0;
    let updatedData = [];

    // Process each key in the data object
    Object.keys(data).forEach((key) => {
      let transactionObj = {};
      let obj = {};

      // Process each element in the data array under the current key
      data[key].forEach((el) => {
        console.log(el < "kkkkkkkkkkk");
        switch (el.name) {
          case "Tax_Amount":
            if (formData?.RCM === "NO") {
              TotalAmount = Addition(TotalAmount, Number(el.value)); // Accumulate to TotalAmount
            }

            obj[el.name] = el.value; // Assign the value to obj
            break;
          case "Amount":
            transactionObj.Amount = Number(el.value);
            obj[el.name] = el.value; // Same assignment as for "Tax_Amount"
            TotalAmount = Addition(TotalAmount, Number(el.value));
            break;
          default:
            if (el.name.includes("Stock_Item")) {
              obj["Stock_Item"] = MasterData[key]?.[el.name]?._id;
            } else if (el.name.includes("Account")) {
              obj["Account"] = {
                _id: MasterData[key]?.[el.name]?.Account_Balance_Id,
                Account_Name: MasterData[key]?.[el.name]?.Search_Value || MasterData[key]?.[el.name]?.Account_Name,
              };
              transactionObj["Account_ID"] = MasterData[key]?.[el.name]?.Account_Balance_Id;
            } else if (el.name.includes("Tax_Group")) {
              obj["Tax_Group"] = MasterData[key]?.[el.name]?._id;
            } else if (el.name.includes("Tax_Code")) {
              obj["Tax_Code"] = MasterData[key]?.[el.name]?._id;
            } else {
              obj[el.name] = el.value; // Assign values for other fields
            }

            break;
        }
      });
      if (formData?.Sales_Account_Selection == "Common" || formKey == "LMS_Sales_Bill" || formKey == "Sales_Return") {
        console.log(transactionObj, MasterData, MasterData?.Sales_Account?.Account_Balance_Id);
        transactionObj["Account_ID"] = MasterData?.Sales_Account?.Account_Balance_Id;
      }
      obj["Entry_For"] = Entry_For;
      if (transactionObj.Account_ID && transactionObj.Amount) {
        if (TransactionMap[transactionObj.Account_ID]) {
          TransactionMap[transactionObj.Account_ID].Amount += transactionObj.Amount;
        } else {
          TransactionMap[transactionObj.Account_ID] = {
            ...transactionObj,
            Transaction_Type: ["Purchase_Bill", "Credit_Note"].includes(formKey) ? "Debit" : "Credit",
          };
        }
      }

      updatedData.push(obj);
    });

    let TransactionArray = Object.values(TransactionMap);

    console.log({ updatedData, TransactionArray, TotalAmount }, "Final output");
    return { updatedData, TransactionArray, TotalAmount };
  } else if (Entry_For === "Tax") {
    console.log(data, formData);
    let TransactionMap = {};
    let UpdatedDataMap = [];
    if (data.length == 1 && data[0].Amount) {
      console.log(MasterData);
      let ID = MasterData?.Party?.Account_Balance_Id;
      TransactionMap[ID] = {
        Account_ID: ID,
        Transaction_Type: ["Purchase_Bill", "Credit_Note"].includes(formKey)
          ? "Credit"
          : ["Sales_Bill", "Dedit_Note"].includes(formKey)
          ? "Debit"
          : "",
        Amount: data[0].Amount,
      };
    }
    let updatedData = data?.map((el) => {
      let accountId = el.Name === "Total" ? MasterData?.Party?.Account_Balance_Id : el[Type]?._id;
      let amount = Number(Number(el?.Amount)?.toFixed(2));

      // Transaction accumulation logic
      if (accountId && amount) {
        if (TransactionMap[accountId]) {
          TransactionMap[accountId].Amount += amount;
        } else {
          TransactionMap[accountId] = {
            Account_ID: accountId,
            Transaction_Type:
              el?.Transaction_Type === "Cr" || el?.Transaction_Type === "Credit"
                ? "Credit"
                : el?.Transaction_Type === "Dr" || el?.Transaction_Type === "Debit"
                ? "Debit"
                : "",
            Amount: amount,
          };
        }

        // UpdatedData accumulation logic
      }

      UpdatedDataMap.push({
        Account: {
          _id: accountId,
          // Account_Name: el?.Expense_Account?.Account_Name,
        },
        Account_ID: accountId,
        Name: el?.Name,
        Rate: el?.Rate,
        Tax_Type: el?.Tax_Type,
        Transaction_Type: el?.Transaction_Type,
        Amount: amount,
        Entry_For: Entry_For,
        unit: el.unit || "",
        Discount: el.Discount || "",
        applyRoundOff: el.applyRoundOff || false,
      });

      return null; // We'll use the UpdatedDataMap for final output, not mapping results directly
    });

    // Convert the TransactionMap and UpdatedDataMap back to arrays for returning
    let TransactionArray = Object.values(TransactionMap).filter((t) => t.Account_ID && t.Amount);
    updatedData = UpdatedDataMap;
    let t = [...TransactionArray];
    console.log({ updatedData, TransactionArray }, "Orion");
    return { updatedData, TransactionArray: t, test: "hiii" };
  }
};

export const calculateAmount = (rate, quantity) => {
  return rate * quantity;
};

export const calculateTax = (amount, rate) => {
  return ((rate / 100) * amount).toFixed(2);
};

export const getFieldValue = (data, fieldName) => {
  const field = data.find((el) => el.name === fieldName);
  return field && field.value ? field.value : null;
};

export const updateFieldInRow = (rowData, id, newValue) => {
  return rowData.map((el) => {
    if (el.id === id) {
      return { ...el, value: newValue };
    }
    return el;
  });
};

export const getTotalAmount = (formdata) => {
  let TotalAmount = 0;
  console.log(formdata);
  formdata.forEach((item) => {
    // Process each element in the data array under the current key
    if (item.Name == "Total") {
      console.log(item, "TotalAmount");
      TotalAmount = Number(item.Amount);
    }
  });

  return TotalAmount;
};

export const getTotalForFreightBill = (tableData) => {
  console.log(tableData, "getTotalForFreightBill");
  const totalSum = tableData?.reduce((sum, item) => Addition(sum, item.Total || 0), 0);
  return totalSum;
};

export const FreightInfo = (data) => {
  const result = data?.map((item) => ({
    BillFreightIds: item._id,
    Type: item.Type,
  }));
  return result;
};
export const getItemAmount = (tableData) => {
  let TotalAmount = 0;

  for (const key of Object.keys(tableData)) {
    for (const item of tableData[key]) {
      if (item.name == "Amount") {
        TotalAmount = Addition(Number(TotalAmount), Number(item.value));
      }
    }
  }
  return TotalAmount;
};

export const getBookingTotalAmount = (tableData) => {
  let TotalAmount = tableData?.reduce((accumulator, currentValue) => {
    return accumulator + currentValue.Bill_Party_Sub_Total;
  }, 0);

  return TotalAmount;
};

export const getCNTotalAmount = (tableData) => {
  let TotalAmount = tableData?.reduce((accumulator, currentValue) => {
    if (currentValue.Total != null) {
      return accumulator + currentValue.Total;
    }
    return accumulator;
  }, 0);

  return TotalAmount;
};

export function deepEqual(obj1, obj2) {
  if (obj1 === obj2) {
    return true;
  }
  if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

export const calculatePercentage = (Party, alldata, hsn) => {
  let per;
  if (alldata?.RCM == "YES") {
    per = hsn?.RCM?.Tax_Percentage;
  } else if (Party?.GST_Number) {
    per = hsn?.FCM?.Tax_Percentage;
  } else {
    per = hsn?.FCM_For_Unregister?.Tax_Percentage;
  }

  return per;
};
export const calculatePercentageFromTaxGroup = (Tax_Group) => {
  let per = Tax_Group?.Tax_Rate?.Tax_Percentage;

  return per;
};

export function consolidateTransactions(transactions, References, Party) {
  const result = {};

  transactions.forEach((transaction) => {
    const { Account_ID, Amount, Transaction_Type } = transaction;

    if (result[Account_ID]) {
      if (result[Account_ID].Transaction_Type === Transaction_Type) {
        // Same type: add amounts
        // result[Account_ID].Amount += Amount;
        result[Account_ID].Amount =Addition( result[Account_ID].Amount,Amount) ;
      } else {
        // Different types: subtract amounts
        if (result[Account_ID].Amount > Amount) {
          // result[Account_ID].Amount -= Amount;
          result[Account_ID].Amount =Subtraction(result[Account_ID].Amount,Amount) ;
        } else {
          result[Account_ID].Amount = Subtraction(Amount , result[Account_ID].Amount);
          result[Account_ID].Transaction_Type = Transaction_Type;
        }
      }
    } else {
      result[Account_ID] = { ...transaction };
    }
    if (
      result[Account_ID]?.Account_ID === Party.Account_Balance_Id &&
      (Party?.Balance_Method === "Bill By Bill" || Party?.Balance_Method === true)
    ) {
      result[Account_ID].References = References;
    }
  });

  // Convert the .result object back to an array
  return Object.values(result);
}

/************************************************************************ */

export const createPurchaseTransaction = (data, Entry_For, FormDataFromRedux, formData = {}, formKey) => {
  let { MasterData } = FormDataFromRedux;
  MasterData = MasterData[formKey];
  console.log(data, Entry_For);
  if (Entry_For === "Sales" && MasterData) {
    let TransactionMap = {};
    let TotalAmount = 0;
    let updatedData = [];

    // Process each key in the data object
    Object.keys(data).forEach((key) => {
      let transactionObj = {};
      let obj = {};
      // Process each element in the data array under the current key
      data[key].forEach((el) => {
        switch (el.name) {
          case "Tax_Amount":
            if (formData?.RCM === "NO") {
              TotalAmount = Addition(TotalAmount, Number(el.value)); // Accumulate to TotalAmount
            }

            obj[el.name] = el.value; // Assign the value to obj
            break;
          case "Amount":
            transactionObj.Amount = Number(el.value);
            obj[el.name] = el.value; // Same assignment as for "Tax_Amount"
            TotalAmount = Addition(TotalAmount, Number(el.value));
            break;
          default:
            if (el.name.includes("Stock_Item")) {
              obj["Stock_Item"] = MasterData[key]?.[el.name]?._id;
            } else if (el.name.includes("Account")) {
              obj["Account"] = {
                _id: MasterData[key]?.[el.name]?._id,
                Account_Name: MasterData[key]?.[el.name]?.Search_Value || MasterData[key]?.[el.name]?.Account_Name,
              };
              transactionObj["Account_ID"] = MasterData[key]?.[el.name]?.Account_Balance_Id;
            } else if (el.name.includes("Tax_Group")) {
              obj["Tax_Group"] = MasterData[key]?.[el.name]?._id;
            } else {
              obj[el.name] = el.value; // Assign values for other fields
            }
            break;
        }
      });

      obj["Entry_For"] = Entry_For;
      if (transactionObj.Account_ID && transactionObj.Amount) {
        if (TransactionMap[transactionObj.Account_ID]) {
          TransactionMap[transactionObj.Account_ID].Amount += transactionObj.Amount;
        } else {
          TransactionMap[transactionObj.Account_ID] = {
            ...transactionObj,
            Transaction_Type: "Debit",
          };
        }
      }

      updatedData.push(obj);
    });

    let TransactionArray = Object.values(TransactionMap);

    console.log({ updatedData, TransactionArray, TotalAmount }, "Final output");
    return { updatedData, TransactionArray, TotalAmount };
  } else if (Entry_For === "Tax") {
    console.log(data);
    let TransactionMap = {};
    let UpdatedDataMap = [];

    let updatedData = data?.map((el) => {
      let accountId = el?.Expense_Account?.Account_Balance_Id;
      let amount = Number(Number(el?.Amount)?.toFixed(2));

      // Transaction accumulation logic
      if (accountId && amount) {
        if (TransactionMap[accountId]) {
          TransactionMap[accountId].Amount += amount;
        } else {
          TransactionMap[accountId] = {
            Account_ID: accountId,
            Transaction_Type:
              el?.Transaction_Type === "Cr" || el?.Transaction_Type === "Credit"
                ? "Credit"
                : el?.Transaction_Type === "Dr" || el?.Transaction_Type === "Debit"
                ? "Debit"
                : "",
            Amount: amount,
          };
        }

        // UpdatedData accumulation logic
      }

      UpdatedDataMap.push({
        Account: {
          _id: accountId,
          Account_Name: el?.Expense_Account?.Account_Name,
        },
        Account_ID: accountId,
        Name: el?.Name,
        Rate: el?.Rate,
        Transaction_Type: el?.Transaction_Type,
        Amount: amount,
        Entry_For: Entry_For,
      });

      return null; // We'll use the UpdatedDataMap for final output, not mapping results directly
    });

    // Convert the TransactionMap and UpdatedDataMap back to arrays for returning
    let TransactionArray = Object.values(TransactionMap).filter((t) => t.Account_ID && t.Amount);
    updatedData = UpdatedDataMap;

    console.log({ updatedData, TransactionArray }, "madhu");
    return { updatedData, TransactionArray };
  }
};

export function prepareReferenceData(referenceData) {
  const refObj = referenceData?.[1] || {};

  return Object.keys(refObj).map((key) => {
    const items = refObj[key];
    let obj = {};

    for (const item of items) {
      // if (!item || item.name === "Unique_Id") continue;

      if (item.name === "RefDate" && item.value) {
        obj[item.name] = convertToISO(item.value);
        continue;
      }

      if (item.name === "Particular") {
        obj[item.name] = item.value || "";
        if (item.NewRef_Id) {
          obj.NewRef_Id = item.NewRef_Id;
        }
        continue;
      }

      if (item.name) {
        obj[item.name] = item.value;
      }
    }

    return obj;
  });
}

const prepareDataObject = (Data, FormDataFromRedux, Form_Key, Note) => {
  const master = FormDataFromRedux?.MasterData?.[Form_Key];
  const Party = master?.Party;

  return {
    ...Data,
    Voucher_Series: master?.Voucher_Series?._id,
    Default_Voucher_Series: master?.Default_Voucher_Series?._id,
    Party: Party?.Account_Balance_Id,
    Entry_Type: replaceUnderscore(Form_Key),
    Voucher_Type: replaceUnderscore(Form_Key),
    Narration: Note,
    RCM: Data?.RCM ? "YES" : "NO",
    Date: Data?.Date ? convertToISO(Data.Date) : undefined,
    Sales_Account: master?.Sales_Account?.Account_Balance_Id,
    Tax_Group: master?.Tax_Group?._id ?? undefined,
  };
};
